import {
    type DepositAccount,
    type ImAccount,
    type RetirementContributionType,
} from '@fruitful/types';
import { atom } from 'jotai';

import type { RetirementDistributionCreateType } from '../hooks/useTestICTWithdrawal';

export interface ApexDepositRequest {
    fromAccount: DepositAccount;
    toAccount: ImAccount;
    amountCents: number;
    contributionYear: number;
    contributionType: RetirementContributionType;
    processingDate: string;
    isRetirementAccount: boolean;
}

export interface ApexWithdrawalRequest {
    fromAccount: ImAccount;
    toAccount: DepositAccount;
    amountCents: number;
    processingDate: string;
    isRetirementAccount: boolean;
    distributionType: RetirementDistributionCreateType;
    liquidateAccount: boolean;
}

export const apexDepositRequestAtom = atom<Partial<ApexDepositRequest> | null>(
    null,
);

export const apexWithdrawalRequestAtom =
    atom<Partial<ApexWithdrawalRequest> | null>(null);

export const selectedApexTransferAccount = atom<ImAccount | null>(null);
export const closedImAccountsAtom = atom<ImAccount[]>([]);
